module.exports = __webpack_public_path__ + "static/media/img_25.266d0eec.png";